module.exports = __webpack_public_path__ + "static/scale-model-of-akron-summit-convention-&-visitors-bureau-in-akron-ohio-516d88a526194fc3976df47502a33f7e.png";